enum GOOGLE_MAP_STYLE {
  DEFAULT = 'default',
  BLACK_WHITE = 'black_white',
}

const DEFAULT = 'default';
const GREY_MAP_STYLED = 'greyMapStyled';

export const GOOGLE_MAP_STYLE_MAPPER = {
  [GOOGLE_MAP_STYLE.DEFAULT]: DEFAULT,
  [GOOGLE_MAP_STYLE.BLACK_WHITE]: GREY_MAP_STYLED,
};

export default GOOGLE_MAP_STYLE;